export default __webpack_public_path__ + "static/media/sergio650.430fbe2c.png";